import { select, Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { landComparableSizeInMetric } from "../../v3/comparable/land";
import { BaseDataSource } from "../../_base/crud";
import { AssetClassLandModel } from "../_models/asset-class-land.model";
import { selectAssetClassLandInStore, selectAssetClassLandPageLoading, selectAssetClassLandShowInitWaitingMessage } from "../_selectors/asset-class-land.selectors";

export class AssetClassLandDataSource extends BaseDataSource {
    trashed = 0;

    constructor(
        private store: Store<AppState>
    ) {
        super();

        this.loading$ = this.store.pipe(
            select(selectAssetClassLandPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectAssetClassLandShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectAssetClassLandInStore)
        ).subscribe(response => {
            let items = response.items.map(item => areaAdder(item));
            items = items.map(item => tenureAdder(item));
            this.paginatorTotalSubject.next(response.totalCount);
            this.trashed = response.trashed;
            this.entitySubject.next(items);
        })
    }
}

export function areaAdder(ac: any): any {
    const size = landComparableSizeInMetric(ac)
    return {
        ...ac,
        area: size,
        size: `${size.toFixed(2)} m2 (${(size * 10.7639).toFixed(2)} ft2)`
    }
}

function copy(tenures: any[]): any[] {
    const temp = [];
    tenures.forEach(t => temp.push(Object.assign({}, t)));
    return temp;
}

function tenurePicker(tenures: any[]): any {
    const ts = copy(tenures);
    ts.sort((a, b) => {
        const aDate = a.source.source_type_id != 1 ? new Date(a.source.information_date) : new Date(a.source.transaction_date);
        const bDate = b.source.source_type_id != 1 ? new Date(b.source.information_date) : new Date(b.source.transaction_date);
        return bDate.getTime() - aDate.getTime();
    });  
    return ts[0];
}

export function tenureAdder(e: any): any {
    if (e.considerations.length == 0) {
        return {...e, display_tenures: []};
    }
    const lt = e.considerations.filter(t => t.consideration_type_id == 1);
    const ft = e.considerations.filter(t => t.consideration_type_id == 2);
    let tenures = [];
    if (lt.length > 0) {
        tenures.push(tenurePicker(lt));
    }
    if (ft.length > 0) {
        tenures.push(tenurePicker(ft));
    }

    return {...e, display_tenures: tenures.map(tenure => {
        return {
            ...tenure,
            rent_basis: tenure.rent_basis_id == 1
                ? 'month'
                : tenure.rent_basis_id == 2
                    ? 'quarter'
                    : 'year'
        }
    })}
}